export const Challenge_Overview_DA = {
  // Challenges overview
  challenges: {
    create_btn: "Opret en challenge",
    desc: "Deltag i challenges i et eller flere spil.",
    headline: {
      mine: "Mine challenges",
      new: "Opdag nye",
      zone: "Zone aktivitet",
    },
    badges: {
      mine: "Mine",
      new: "Opdag nye",
      zone: "Zone aktivitet",
    },
    status: {
      ongoing: "I gang",
      upcoming: "Kommende",
      finished: "Afsluttet",
    },
    tooltips: {
      upcoming: "Starter snart",
      finished: "Afsluttet",
    },
    games: {
      all: "Alle spil",
    },
  },
};
